import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { StorageService } from './storage.service';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

import { Tutorial, TutorialSection } from '../interfaces/tutorial';

@Injectable({
  providedIn: 'root',
})
export class TutorialsService {
  TUTORIAL_apiUrl = `${environment.apiUrl}/tutorial`;
  TABLET_API_URL = `${environment.tabletUrl}/tutorial`;

  constructor(
    private http: HttpClient,
    private storageService: StorageService
  ) {}

  // CRD Tutorials

  createTutorial(tutorial: Tutorial): Observable<void> {
    const token = this.storageService.get('accessToken', false);
    const httpHeaders = new HttpHeaders().set('Access-Token', token);

    let formData = new FormData();

    formData.append('name', tutorial.name);
    formData.append('description', tutorial.description);
    formData.append('file', tutorial.file);
    formData.append('section', tutorial.section);
    formData.append('sectionRelationId', '' + tutorial.sectionRelationId);
    formData.append('format', tutorial.format);
    formData.append('allowedUserType', tutorial.allowedUserType);

    return this.http.post<void>(this.TUTORIAL_apiUrl, formData, {
      headers: httpHeaders,
    });
  }

  deleteTutorial(tutorial: Tutorial): Observable<void> {
    const token = this.storageService.get('accessToken', false);
    const httpHeaders = new HttpHeaders().set('Access-Token', token);

    return this.http.delete<void>(`${this.TUTORIAL_apiUrl}/${tutorial.id!}`, {
      headers: httpHeaders,
    });
  }

  getAllTutorials(): Observable<TutorialSection[]> {
    const token = this.storageService.get('accessToken', false);
    const httpHeaders = new HttpHeaders().set('Access-Token', token);

    return this.http.get<TutorialSection[]>(
      `${environment.apiUrl}/tutorials/all`,
      {
        headers: httpHeaders,
      }
    );
  }

  getAllSections(queryParams: string): Observable<TutorialSection[]> {
    const token = this.storageService.get('accessToken', false);
    const httpHeaders = new HttpHeaders().set('Access-Token', token);

    return this.http.get<TutorialSection[]>(
      `${environment.tabletUrl}/tutorials/all?${queryParams}`,
      {
        headers: httpHeaders,
      }
    );
  }

  getVideo(tutorialId: number): Observable<any> {
    const httpHeaders = new HttpHeaders();
    httpHeaders.set('Accept', 'video/mp4');

    return this.http.get<any>(`${this.TABLET_API_URL}/${tutorialId}`, {
      headers: httpHeaders,
      responseType: 'blob' as 'json',
    });
  }
}
